export default {
      id: "color_pill-usage",
      viewBox: "0 0 88 88",
      url: __webpack_public_path__ + "sprite.svg#color_pill",
      toString: function () {
        return this.url;
      }
    }